import script from "./BlogView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogView.vue?vue&type=script&setup=true&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=6c33c2aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c33c2aa"]])

export default __exports__